import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button, Spinner, OverlayTrigger, Popover } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import QueryTable from '../QueryTable';
import { PencilSquare } from 'react-bootstrap-icons';

class OrderHistory extends ChemComponent {
	constructor(props) {
		super(props);

		var search = {
			USERID: this.getFASUserID(),
			REQUESTDATE_FROM: null,
			REQUESTDATE_TO: null,
			BILLINGDATE: null,
			COMPLETE: null,
			STATUS: []
		};
		
		if (props.search) {
			var propsSearch = this.copyObject(props.search);
			this.mergeObject(search, propsSearch);
			search = propsSearch;
		}
		
		var requestListInit = this.copyRequestList();
		requestListInit.query.search = this.constructSearch(search);

		this.state = {
			requestList: requestListInit,
			archive: {
				BILLINGDATE: null
			},
			search: search,
			searchCount: null,
			renderKey: 0
		};
	}
	
	getFASUserID() {
		if (('' + this.props.user.uid).startsWith('fas.user.')) {
			return this.props.user.uid.substring(9);
		} else {
			return -1;
		}
	}
	
	componentDidUpdate(prevProps) {
		if (this.props.search && (this.state.search.treeMenuClickCount !== this.props.search.treeMenuClickCount)) {
			var newRequestList = this.copyRequestList();
			newRequestList.query.search = this.constructSearch(this.props.search);
			this.mergeState({
				requestList: newRequestList,
				search: this.copyObject(this.props.search),
				searchCount: null,
				renderKey: this.state.renderKey + 1
			});
		}
	}

	copyRequestList() {
		// make copy of request list
		var newRequestList = this.copyTable(requestList);
		// if user is not an admin
		if (!this.isAdmin()) {
			// locate status column
			var statusIdx = this.findColumnByAccessor(newRequestList.columns, 'STATUS');
			// remove status column
			newRequestList.columns.splice(statusIdx, 1);
		}
		
		return newRequestList;
	}
	
	copyExportColumns() {
		// make copy of export columns
		var newExportColumns = this.copyColumns(exportColumns);
		// if user is not an admin
		if (!this.isAdmin()) {
			// locate status column
			var statusIdx = this.findColumnByAccessor(newExportColumns, 'STATUS');
			// remove status column
			newExportColumns.splice(statusIdx, 1);
		}
		
		return newExportColumns;
	}

	isAdmin() {
		return ('' + this.props.user.uid).startsWith('fas.admin.') ||
			(this.props.user.fas && this.props.user.fas.authLevel === 1);
	}

	onChangeSearch(accessor, value) {
		var search = this.copyObject(this.state.search);
		this.setByAccessor(search, accessor, value);
		this.mergeState({ search: search });
	}

	constructSearch(data) {
		// construct search terms
		var search = {
			Operator: 'and',
			Children: [
				{ Attribute: 'USERID', Operator: '=', LongValue: data.USERID },
				{ Attribute: 'DELETE_FLAG', Operator: 'is null' }
			]
		};

		if (!this.isEmpty(data.REQUESTDATE_FROM)) search.Children.push({ Attribute: 'REQUESTDATE', Operator: '>=', DateValue: data.REQUESTDATE_FROM });
		if (!this.isEmpty(data.REQUESTDATE_TO)) search.Children.push({ Attribute: 'REQUESTDATE', Operator: '<', DateValue: this.nextDayMVC(data.REQUESTDATE_TO) });
		if (!this.isEmpty(data.BILLINGDATE)) {
			if (data.BILLINGDATE === 'NOTBILLED') {
				search.Children.push({ Attribute: 'BILLINGDATE', Operator: 'is null' });
			} else {			
				search.Children.push({ Attribute: 'BILLINGDATE', Operator: '=', DateValue: this.dateTimeToMVC(this.getDate(data.BILLINGDATE)) });
			}
		}
		if (!this.isEmpty(data.STATUS)) search.Children.push({ Attribute: 'STATUS', Operator: 'in', StringList: data.STATUS });
		if (!this.isEmpty(data.COMPLETE)) {
			if (data.COMPLETE === 1) {
				search.Children.push({ Attribute: 'COMPLETE', Operator: '=', LongValue: 1 });
			} else {
				search.Children.push({ Attribute: 'COMPLETE', Operator: 'is null' });
			}
		}
		
		return search;
	}

	onSubmitSearch(event) {
		var newRequestList = this.copyRequestList();
		newRequestList.query.search = this.constructSearch(this.state.search);
		this.mergeState({ 
			requestList: newRequestList,
			searchCount: null,
			renderKey: this.state.renderKey + 1
		});
		if (event && event.nativeEvent && event.nativeEvent.submitter) event.nativeEvent.submitter.blur();
	}
	
	onSearchResult(data) {
		this.mergeState({
			searchCount: data.ResultCount
		});
	}
	
	addRequest() {
		this.props.navigate('/FAS/AddRequest');
	}
	
	editRequest(facilitiesId, requestId) {
		if (facilitiesId === 34) {
			this.props.navigate('/FAS/Microrequests/' + requestId);
		} else if (facilitiesId === 33) {
			this.props.navigate('/FAS/Xrayrequests/' + requestId);
		}
	}

	render() {
		
		var exportData = this.createHiddenFormData({
			__RequestVerificationToken: this.props.user.antiForgeryToken,
			title: 'Requests',
			columns: this.copyExportColumns(),
			entity: 'FAS.REQUESTS_VW',
			search: this.constructSearch(this.state.search),
			order: 'REQUESTDATE desc'
		});			

		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', marginBottom: '20px', border: '1px solid #ccc', borderRadius: 6, backgroundColor: '#FEFEFE' }}>
				  <Container fluid>	
					<Row>
					  <Col xs={12}>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>Requests</div>
						<Container fluid>
						  <Row>
						    <Col xs={9}>
							  <ChemEdit parent={this} user={this.props.user} columns={requestSearch} data={this.state.search}
								renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
							</Col>
							<Col xs={3}>
							  <ChemEdit parent={this} user={this.props.user} columns={statusSearch} data={this.state.search}
								renderKey={this.state.renderKey} onChange={(accessor, value) => this.onChangeSearch(accessor, value)} />
							</Col>
						  </Row>
						</Container>
					  </Col>
					</Row>
					<Form.Group as={Row} style={{ borderTop: '1px solid #eee', paddingTop: 10, marginBottom: 10 }}>
					  <Col xs={3} style={{ marginTop: 8}}>
						{this.isEmpty(this.state.searchCount) ? <Spinner animation='border' as='div' size='sm' style={{ marginRight: '4px' }} /> : this.state.searchCount} records found.
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Excel'} method='POST'>
							{exportData.map((excelFormField, index) => {
								return (<input key={index} type='hidden' name={excelFormField.name} value={excelFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to Excel</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Excel.png'} style={{ paddingLeft: '20px' }} alt="Export to Excel" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={1} style={{ marginTop: 6}}>
						<form action={this.getConfig().host + '/Home/Pdf'} method='POST'>
							{exportData.map((pdfFormField, index) => {
								return (<input key={index} type='hidden' name={pdfFormField.name} value={pdfFormField.value} />);
							})}
							<OverlayTrigger trigger="hover" overlay={<Popover><Popover.Header as="h3">Export to PDF</Popover.Header></Popover>}>
							  <input type='image' src={this.getConfig().host + '/Content/Icons/Pdf.png'} style={{ paddingLeft: '20px' }} alt="Export to PDF" />
							</OverlayTrigger>
						</form>
					  </Col>
					  <Col xs={7}>
						<Button id="search" variant="warning" type="button" className="float-end" onClick={(event) => this.onSubmitSearch(event)}>Search</Button>
					  </Col>
					</Form.Group>
				  </Container>
				</Col>
			  </Row>
			  <Row>
				<Col>
				  <QueryTable renderKey={this.state.renderKey} parent={this} name='FAS_Requests' table={this.state.requestList}
				    onResult={(data) => this.onSearchResult(data)} offsetHeight='260px' />
				</Col>
			  </Row>
			</Container>
		</>);		
	}
}

const requestSearch = [
	{ Header: 'Request Date From', accessor: 'REQUESTDATE_FROM', type: 'date', row: 0, col: 0 },
	{ Header: 'Request Date To', accessor: 'REQUESTDATE_TO', type: 'date', row: 0, col: 1 },
	{ Header: 'Billing Date', accessor: 'BILLINGDATE', type: 'select', row: 1, col: 0,
		options: { value: 'BILLINGDATE', label: 'BILLINGDATEDISPLAY', entity: 'FAS.BILLINGDATE_SELECT_VW', order: ['BILLEDORDER','BILLINGDATE desc']}},
	{ Header: 'Request Complete', accessor: 'COMPLETE', type: 'select', row: 1, col: 1,
		options: [{ value: null, label: 'All' },{ value: 0, label: 'No' },{ value: 1, label: 'Yes' }]}
];

const statusSearch = [		
	{ Header: 'Status', accessor: 'STATUS', type: 'list', row: 0, col: 0,
		options: [
			{ value: 'Saved', label: 'Saved' },
			{ value: 'Submitted', label: 'Submitted' },
			{ value: 'Updated', label: 'Updated' },
			{ value: 'Completed', label: 'Completed' },
			{ value: 'Archived', label: 'Archived' }
		]
	}
];

const requestList = {
	query: { entity: 'FAS.REQUESTS_VW', search: null, order: 'REQUESTDATE desc' },
	pageSize: 20,
	columns: [
		{ Header: '', accessor: 'FACILITIESID', show: false },
		{ Header: '', accessor: 'ID', width: 25,
			Cell: props => <PencilSquare style={{ cursor: 'pointer' }} 
				onClick={() => props.parent.editRequest(props.row.values.FACILITIESID, props.value)} /> },
		{ Header: 'Request No.', accessor: 'IDDISPLAY', width: 100 },
		{ Header: 'Requester Name', accessor: 'NAME', width: 250 },
		{ Header: 'Facility', accessor: 'CODE', width: 80 },
		{ Header: 'Service', accessor: 'SERVICE', width: 125 },
		{ Header: 'Status', accessor: 'STATUS', width: 100 },
		{ Header: 'Billing Date', accessor: 'BILLINGDATEDISPLAY', width: 100 }
	]
};

const exportColumns = [
	{ Header: 'Request No.', accessor: 'IDDISPLAY', width: 20 },
	{ Header: 'Requester Name', accessor: 'NAME', width: 50 },
	{ Header: 'Facility', accessor: 'CODE', width: 16 },
	{ Header: 'Service', accessor: 'SERVICE', width: 25 },
	{ Header: 'Status', accessor: 'STATUS', width: 20 },
	{ Header: 'Billing Date', accessor: 'BILLINGDATEDISPLAY', width: 20 }
];

export default withRouter(OrderHistory);
